import { faMugHot } from '@fortawesome/pro-solid-svg-icons';

import { useTranslate } from '@growtherapy/i18n';
import { Body, Card, IconBadge, IconBadgeUse } from '@growtherapy/sprout-ui';

export const NoUpcomingAppointmentsCard = () => {
  const t = useTranslate();
  return (
    <Card className='max-h-[80%] sm:w-[40rem] w-full rebrand:p-450 rebrand:rounded-425-450'>
      <IconBadge aria-hidden size='xl' icon={faMugHot} use={IconBadgeUse.Green} className='mx-auto' />
      <Body.Small className='text-neutral-700 mt-6 text-center'>
        {t('telehealth-core:providerIntersessionSummary.takeABreak')}
      </Body.Small>
    </Card>
  );
};
